import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner/lib/helpers';

import helper from '../../../helpers/steinerHelper';
import routeRegister from '../../../helpers/routeRegister';
import { selectors } from '../reducers/sitePhotogallery';

const routes = helper.generateRoutes('sitePhotogallery', selectors);

routes.list.list.breadcrumb = 'Gallerie sito';

const list = _.values(routes.list).map(route => ({
    ...route,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'photogallery-sito' */ `modules/sitePhotogallery/${
                route.componentPath
            }`).then(response => resolve(response.default));
        });
    }
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('sitePhotogallery', routes.patterns, {
    it: 'Gallerie sito'
});
routeRegister.addLinks('sitePhotogallery', links);

export default list;
